export const heroQuotes = [
    {
      heading: "Empowering Businesses with Smart Technology Solutions.",
      subheading: "Delivering innovation, efficiency, and growth through expert IT consulting."
    },
    {
      heading: "Transforming Ideas Into Scalable Digital Realities.",
      subheading: "Your partner in navigating today's technology-driven world."
    },
    {
      heading: "Your Vision, Our Expertise, One Digital Future.",
      subheading: "Strategic IT consulting to drive your success."
    }
  ];
  